interface SubjectProps {
  subject: string;
}

const SubjectLine2 = ({ subject }: SubjectProps) => (
  <h3 className="text-center font-bold underline mb-4 text-[15px] uppercase" style={{fontFamily: "Times New Roman"}}>
    {subject.toUpperCase()}
  </h3>
);

export default SubjectLine2;
